export const DRAG_DISTANCE_INERTIA = 5; // pixels
